"use client";

import { createContext, useContext, useState } from "react";
import type { TPropsWithChildren } from "@/types";

export type TTabsContextType = {
	selectedTab: string | undefined;
	setSelectedTab: (tab: string) => void;
};

const TabsContext = createContext<TTabsContextType | undefined>(undefined);

export default function TabsProvider({
	defaultSelectedTab,
	children,
}: TPropsWithChildren & { defaultSelectedTab?: string }) {
	const [selectedTab, setSelectedTab] = useState<string | undefined>(
		defaultSelectedTab
	);

	return (
		<TabsContext.Provider
			value={{
				selectedTab,
				setSelectedTab,
			}}
		>
			{children}
		</TabsContext.Provider>
	);
}

export const useTabs = () => {
	const context = useContext(TabsContext);

	if (context === undefined) {
		throw new Error("useAuth must be used within an TabsProvider");
	}

	return context;
};
